export const storageAddresses = {
  43112: '0xbf81Dc1F4a38D63c93dfb10b9b8819cF60180F1e',
  43113: '0x399D78327E665D21c8B9582D4843CA5DCA0e7dc4',
  43114: '0x1cEa17F9dE4De28FeB6A102988E12D4B90DfF1a9',
}

// 0x419776D88C06dBc32c07ef2fBB7D1dE1155F3345 ggp
// 43113 is testnet I think

export const GGPAddresses = {
  43113: '0xf60E7F4EF0c94ff463863D2826524B2a1431CBD6',
  43114: '0x69260B9483F9871ca57f81A90D91E2F96c2Cd11d',
}

export const xGGPAddresses = {
  43113: '0x2d79B8cF74D84859818802553D9751cFfeB818C9',
  43114: '0xdF34022e8a280fc79499cA560439Bb6f9797EbD8',
}
